import { PICKUP_POINT_BOOKING_STATUSES } from '@meltingpoint/shared-statuses'

export enum ROUTES {
  HOME = 'home',
  NOT_FOUND = 'notFound',
}

export const TRACKING_STATUS_ORDER = {
  ORDER_VALIDATED: 'order_validated',
  APPOINTMENT_SCHEDULING: 'appointment_scheduling',
  CARRIER_SUPPORT: 'carrier_support',
  DELIVERY_IN_TRANSIT: 'delivery_in_transit',
  DELIVERY_ON_GOING: 'delivery_on_going',
  DELIVERY_AVAILABLE: 'delivery_available',
  DELIVERY_AT_DROP_OFF_LOCATION: 'delivery_at_drop_off_location',
  RETURNED_TO_SENDER: 'delivery_returned_to_sender',
  ORDER_DELIVERED: 'order_delivered',
  ORDER_CANCEL: 'order_cancel',
  ORDER_DELIVERY_CANCELED: 'order_delevery_canceled',
  ORDER_BLOCK_OR_FAILED: 'order_block_or_failed',
  ORDER_IN_PICKUP_POINT: 'order_in_pickup_point',
  ORDER_KO: 'order_ko',
  CARRIER_SUPPORT_KO: 'carrier_support_ko',
}

export const TRACKING_STATUS_COLLECT = {
  COLLECT_VALIDATED: 'COLLECT_VALIDATED',
  COLLECT_READY: 'COLLECT_READY',
  COLLECT_DELIVERED: 'COLLECT_DELIVERED',
  COLLECT_BLOCKED_OR_FAILED: 'COLLECT_BLOCKED_OR_FAILED',
  COLLECT_CANCELLED: 'COLLECT_CANCELLED',
}

export const TRACKING_STATUS_LOCKER = {
  BOOKING_VALIDATED: 'PICK_UP_POINT_BOOKING_VALIDATED',
  BOOKING_READY: 'PICK_UP_POINT_BOOKING_READY',
  BOOKING_DELIVERED: 'PICK_UP_POINT_BOOKING_DELIVERED',
  BOOKING_KO: 'PICK_UP_POINT_BOOKING_KO',
  BOOKING_CANCELLED: 'PICK_UP_POINT_BOOKING_CANCELLED',
}

export const RATING_COLORS = [
  '#E95659',
  '#E87558',
  '#EB8D5A',
  '#EC9F6B',
  '#F0AC44',
  '#F5C33B',
  '#E8CF34',
  '#C4CF4C',
  '#A0CF45',
  '#67CD47',
  '#48CAA7',
]

export const MAX_RATING = 11

export const WOOP_WEBSITE = 'https://www.woopit.fr'

export const MAX_DISPLAYED_CHIPS = 6

export enum ClientPageCategory {
  COLLECT = 'COLLECT',
  DELIVERY = 'DELIVERY',
  LOCKER = 'LOCKER',
}

export enum CollectClientPageType {
  DRIVE_TRACKING = 'DRIVE_TRACKING',
  DRIVE_SLOT = 'DRIVE_SLOT',
  DRIVE_SLOT_SUCCESS = 'DRIVE_SLOT_SUCCESS',
  REPORT_PRESENCE_AT_DRIVE = 'REPORT_PRESENCE_AT_DRIVE',
  REPORT_PRESENCE_AT_DRIVE_SUCCESS = 'REPORT_PRESENCE_AT_DRIVE_SUCCESS',
  DRIVE_SURVEY = 'DRIVE_SURVEY',
  DRIVE_CONFIRMATION = 'DRIVE_CONFIRMATION',
}

export enum LockerClientPageType {
  LOCKER_TRACKING = 'LOCKER_TRACKING',
  LOCKER_SURVEY = 'LOCKER_SURVEY',
  LOCKER_CONFIRMATION = 'LOCKER_CONFIRMATION',
  LOCKER_PICKUP_POINT = 'LOCKER_PICKUP_POINT',
}

export enum DeliveryClientPageType {
  TRACKING = 'TRACKING',
  APPOINTMENT = 'APPOINTMENT',
  MULTI_TRACKING = 'MULTI_TRACKING',
  SURVEY = 'SURVEY',
  CONFIRMATION = 'CONFIRMATION',
  APPOINTMENT_CONFIRM = 'APPOINTMENT_CONFIRM',
}

export const ClientPageType = {
  COLLECT: CollectClientPageType,
  DELIVERY: DeliveryClientPageType,
  LOCKER: LockerClientPageType,
}

export enum QuestionType {
  SCORE_TYPE_RECOMMENDATION = 'SCORE_TYPE_RECOMMENDATION',
  SCORE_TYPE_SATISFACTION = 'SCORE_TYPE_SATISFACTION',
  CUSTOM = 'CUSTOM',
}

export const ALLOWED_LOCKER_SURVEY_BOOKING_STATUSES = [
  PICKUP_POINT_BOOKING_STATUSES.LOADING_OK,
  PICKUP_POINT_BOOKING_STATUSES.COLLECTION_OK,
  PICKUP_POINT_BOOKING_STATUSES.COLLECTION_KO,
]
export const ALLOWED_LOCKER_PICKUP_POINT_BOOKING_STATUSES = [
  PICKUP_POINT_BOOKING_STATUSES.LOADING_OK,
  PICKUP_POINT_BOOKING_STATUSES.COLLECTION_OK,
  PICKUP_POINT_BOOKING_STATUSES.COLLECTION_KO,
]

export enum MESSAGE_TYPES {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}
// timeouts in ms
export const MESSAGE_TIMEOUTS = {
  ERROR: 5000,
  SUCCESS: 3000,
  WARNING: 3000,
  DEFAULT: 5000,
}

export const REDIRECTION_DELAY = 1000
export const DEFAULT_LANGUAGE = 'fr'
